import { useEffect, useRef, useState } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { fileUrl } from "../lib/api";

/** Image with scroll-reveal + configurable animation type from site config. */
export const AnimatedImage = ({ src, alt = "", className = "", overrideType, ...rest }) => {
    const { config } = useSiteConfig();
    const animationType = overrideType || config?.animation_type || "fade";
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!ref.current) return;
        const el = ref.current;
        const io = new IntersectionObserver(
            ([e]) => {
                if (e.isIntersecting) {
                    setVisible(true);
                    io.disconnect();
                }
            },
            { threshold: 0.15 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, []);

    const animClass =
        animationType === "slide"
            ? "y-anim-slide"
            : animationType === "zoom"
            ? "y-anim-zoom"
            : animationType === "none"
            ? "y-anim-none"
            : "y-anim-fade";

    return (
        <div ref={ref} className={`overflow-hidden ${className}`} data-testid="animated-image-wrapper">
            {visible && (
                <img
                    src={fileUrl(src)}
                    alt={alt}
                    className={`w-full h-full object-cover ${animClass}`}
                    loading="lazy"
                    {...rest}
                />
            )}
            {!visible && <div className="w-full h-full bg-muted" />}
        </div>
    );
};

export default AnimatedImage;
